import React, { useEffect } from "react";
import hljs from "highlight.js";
import "highlight.js/styles/vs.css";

export const CodeViewer = (props) => {
  useEffect(() => {
    hljs.initHighlighting();
  }, []);

  return (
    <pre>
      <code
        dangerouslySetInnerHTML={{
          __html: props.code,
        }}
      ></code>
    </pre>
  );
};
